/* eslint-disable import/prefer-default-export */
import React from "react"
import {
    NO_ARCHITECTURAL_CONSTRAINTS,
    IEC_61508_2010,
    IEC_61508_1998,
    IEC_61511_2016,
    IEC_61511_2003,
} from "const"
import { SilProjectDevice, SilResultProjectDevice } from "server/models"
import { SilArchitecturalConstraints } from "client/utils"
import { LangType } from "client/store"
import { InsufficientData } from "client/components"
import * as Formulas from "client/pages/sil/formulas"

// get device SIL according to selected Architecture Constraints of subsystem
export const getModelSil = (
    device: SilProjectDevice | SilResultProjectDevice,
    architecturalConstraints: SilArchitecturalConstraints,
    lang: LangType,
    textError = false,
) => {
    const calculatedSFF = Formulas.sff({
        sd: device.sd,
        su: device.su,
        dd: device.dd,
        du: device.du,
    })
    const calculatedDC = Formulas.dc({
        dd: device.dd,
        du: device.du,
    })

    const SFF = device.failureRate ? calculatedSFF : device.sff
    const DC = device.failureRate ? calculatedDC : device.dc

    if (device.sil > 0) {
        if (architecturalConstraints === NO_ARCHITECTURAL_CONSTRAINTS) return null
        return lang[`sil_${device.sil}`]
    }
    if (architecturalConstraints === NO_ARCHITECTURAL_CONSTRAINTS) {
        return null
    } if (architecturalConstraints === IEC_61508_2010) {
        return Formulas.iec_61508_2010_device({
            type: device.type,
            mode: Formulas.getSilMode(device),
            provenInUse: device.provenInUse,
            sff: SFF,
            dc: DC,
            lang,
            silOnly: true,
            textError,
        })
    } if (architecturalConstraints === IEC_61508_1998) {
        return Formulas.iec_61508_1998_device({
            type: device.type,
            sff: SFF,
            lang,
            silOnly: true,
            textError,
        })
    } if (architecturalConstraints === IEC_61511_2016) {
        return Formulas.iec_61511_2016_device({
            type: device.type,
            mode: Formulas.getSilMode(device),
            provenInUse: device.provenInUse,
            dc: DC,
            lang,
            silOnly: true,
            textError,
        })
    } if (architecturalConstraints === IEC_61511_2003) {
        return Formulas.iec_61511_2003_device({
            provenInUse: device.provenInUse,
            logicSolver: device.logicSolver,
            sff: SFF,
            lang,
            silOnly: true,
            textError,
        })
    }
    return textError ? lang.insufficientData : <InsufficientData />
}
